module.exports = __webpack_public_path__ + "static/media/Линия АХП.1d817e51.jpg";